import { Button, Modal, message } from "antd";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import ReactToPrint from "react-to-print";
import logo from "../../Assets/Images/logoNew.jpg";
// import Companyseal from "../../Assets/Images/seal.JPG";
import Companyseal from "../../Assets/Images/sahari-seal.png";
import LoadingBox from "../../Components/LoadingBox";
import { API, Headers } from "../../Config";
import "./style.css";

function PrintCustomerInvoiceModal2(props) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [boxItems, setBoxItems] = useState([]);
  const componentRef = useRef();

  useEffect(() => {
    loadDetails();
    if (props?.item?.box_number) {
      loaddata(props?.item?.box_number);
    }
  }, []);

  const loadDetails = () => {
    setBoxItems(props.item.boxe_item);
  };

  const medianBoxNum = Math.floor(boxItems && boxItems.length / 2);

  let requestData = {
    is_customer_invoice_print: true,
  };
  const isPrinted = () => {
    axios({
      method: "put",
      url:
        API.BASR_URL +
        API.BOXES_ACTIONS +
        "print/" +
        props.item.box_number +
        "/is_customer_invoice_print",
      headers: Headers(),
      data: requestData,
    })
      .then(function (response) {
        setLoading(false);
        if ([200, 201].includes(response.status)) {
          message.success("Success");
          props.onClose();
          props.reload();
        }
      })
      .catch(function (error) {
        setLoading(false);
        message.error("Oops.Something went wrong");
        console.log(error);
      });
  };

  const loaddata = (id) => {
    axios
      .get(API.BASR_URL + API.BOXES_ACTIONS_BY_BOX_NUMBER + `${id}`, {
        headers: Headers(),
      })
      .then(function (response) {
        if (response?.data) {
          setData(response?.data);
          message.success("Success");
        } else {
          message.error("Oops.Something went wrong");
        }
        setLoading(false);
      })
      .catch(function (error) {
        message.error(error || "Oops.Something went wrong");
      });
  };
  return (
    <Modal
      visible={props.visible}
      onOk={() => props.onClose()}
      onCancel={() => props.onClose()}
      width={900}
      footer={null}
    >
      {loading ? (
        <LoadingBox />
      ) : (
        <div>
          <div ref={componentRef}>
            <div
              className="print-invoice-page"
              style={{
                padding: "20px",
                margin: "0 auto",
                maxWidth: "100%",
                width: "100%",
                overflow: "visible",
              }}
            >
              <table
                className="print-invoice-table"
                style={{
                  width: "100%",
                  margin: "0 auto",
                  tableLayout: "auto",
                }}
              >
                <tr>
                  <td colSpan={2}>
                    <img src={logo} width="" className="InvoiceLogo" />
                  </td>
                  <td></td>
                  <td colSpan={2}>
                    <div className="print-invoice-table-headertxt">
                      <div
                        className="print-invoice-table-headertxt1"
                        style={{ fontSize: "10px", textTransform: "uppercase" }}
                      >
                        HO:
                        {props.item.created_user &&
                        props.item.created_user.branch
                          ? `${
                              (props.item.created_user.branch?.name,
                              props.item.created_user.branch?.office_address)
                            }`
                          : null}
                      </div>
                      <div
                        className="print-invoice-table-headertxt1"
                        style={{ fontSize: "10px" }}
                      >
                        PH:
                        {props.item.created_user &&
                        props.item.created_user.branch
                          ? `${props.item.created_user.branch?.mobile}`
                          : null}
                      </div>
                      <div
                        className="print-invoice-table-headertxt1"
                        style={{ fontSize: "10px" }}
                      >
                        INVOICE DATE:{" "}
                        {props?.item?.createdAt &&
                          moment(props.item?.createdAt).format("DD-MM-YYYY")}
                      </div>
                      <div
                        className="print-invoice-table-headertxt1"
                        style={{ fontSize: "10px" }}
                      >
                        BOOKED STAFF:{" "}
                        {props.item.created_user &&
                          props.item.created_user.name}
                      </div>
                      <div
                        className="print-invoice-table-headertxt1"
                        style={{ fontSize: "10px" }}
                      >
                        BOOKED BRANCH:{" "}
                        {props.item.created_user &&
                          props.item.created_user.branch &&
                          props.item.created_user.branch.name}
                      </div>
                      <div
                        className="print-invoice-table-headertxt1"
                        style={{ fontSize: "10px" }}
                      >
                        BOOKED DATE:{" "}
                        {props.item?.createdAt &&
                          moment(props.item?.createdAt).format("DD-MM-YYYY")}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colSpan={5}>
                    <div className="print-invoice-txt4">CUSTOMER INVOICE</div>
                  </td>
                </tr>
                <tr>
                  <td colSpan={5}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "30px",
                      }}
                    >
                      {/* Sender Info - Left Side */}
                      <div
                        style={{
                          width: "48%",
                          padding: "20px",
                        }}
                      >
                        <div
                          className="print-invoice-txt1"
                          style={{
                            fontWeight: "bold",
                            marginBottom: "6px",
                            fontSize: "16px",
                            color: "#2c3e50",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                          }}
                        >
                          SENDER INFO
                        </div>
                        <div
                          className="print-invoice-txt2"
                          style={{
                            marginBottom: "12px",
                            fontSize: "13px",
                            lineHeight: "1",
                            color: "#34495e",
                          }}
                        >
                          <strong
                            style={{
                              color: "#2c3e50",
                              minWidth: "60px",
                              display: "inline-block",
                            }}
                          >
                            Name:
                          </strong>{" "}
                          {props.item.collection &&
                            props.item.collection.sender_name}
                        </div>
                        <div
                          className="print-invoice-txt2"
                          style={{
                            marginBottom: "12px",
                            fontSize: "13px",
                            lineHeight: "1",
                            color: "#34495e",
                          }}
                        >
                          <strong
                            style={{
                              color: "#2c3e50",
                              minWidth: "60px",
                              display: "inline-block",
                            }}
                          >
                            Address:
                          </strong>{" "}
                          {props.item.collection &&
                            props.item.collection.sender_address}
                        </div>
                      </div>

                      {/* Receiver Info - Right Side */}
                      <div
                        style={{
                          width: "48%",
                          padding: "20px",
                        }}
                      >
                        <div
                          className="print-invoice-txt1"
                          style={{
                            fontWeight: "bold",
                            marginBottom: "6px",
                            fontSize: "16px",
                            color: "#2c3e50",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                          }}
                        >
                          RECEIVER INFO
                        </div>
                        <div
                          className="print-invoice-txt2"
                          style={{
                            marginBottom: "12px",
                            fontSize: "13px",
                            lineHeight: "1",
                            color: "#34495e",
                          }}
                        >
                          <strong
                            style={{
                              color: "#2c3e50",
                              minWidth: "60px",
                              display: "inline-block",
                            }}
                          >
                            Name:
                          </strong>{" "}
                          {props.item.collection &&
                            props.item.collection.reciver_name}
                        </div>
                        <div
                          className="print-invoice-txt2"
                          style={{
                            marginBottom: "12px",
                            fontSize: "13px",
                            lineHeight: "1",
                            color: "#34495e",
                          }}
                        >
                          <strong
                            style={{
                              color: "#2c3e50",
                              minWidth: "60px",
                              display: "inline-block",
                            }}
                          >
                            Address:
                          </strong>{" "}
                          {props.item.collection &&
                            props.item.collection.reciver_address}
                        </div>
                        <div
                          className="print-invoice-txt2"
                          style={{
                            marginBottom: "12px",
                            fontSize: "13px",
                            lineHeight: "1",
                            color: "#34495e",
                          }}
                        >
                          <strong
                            style={{
                              color: "#2c3e50",
                              minWidth: "60px",
                              display: "inline-block",
                            }}
                          >
                            Phone:
                          </strong>{" "}
                          {props.item.collection &&
                            props.item.collection.reciver_phone}
                          {props.item.collection &&
                            props.item.collection.reciver_altphone &&
                            `, ${props.item.collection.reciver_altphone}`}
                        </div>
                        <div
                          className="print-invoice-txt2"
                          style={{
                            marginBottom: "12px",
                            fontSize: "13px",
                            lineHeight: "1",
                            color: "#34495e",
                          }}
                        >
                          <strong
                            style={{
                              color: "#2c3e50",
                              minWidth: "60px",
                              display: "inline-block",
                            }}
                          >
                            Location:
                          </strong>{" "}
                          {props.item.collection &&
                            props.item.collection.reciver_pincode}
                          {props.item.collection &&
                            props.item.collection.reciver_city &&
                            `, ${props.item.collection.reciver_city}`}
                          {props.item.collection?.reciver_post && (
                            <div
                              className="print-invoices-text3"
                              style={{
                                marginTop: "4px",
                                fontSize: "11px",
                                color: "#666",
                              }}
                            >
                              Post: {props.item.collection.reciver_post}
                            </div>
                          )}
                        </div>
                        <div
                          className="print-invoice-txt2"
                          style={{
                            marginBottom: "12px",
                            fontSize: "13px",
                            lineHeight: "1",
                            color: "#34495e",
                          }}
                        >
                          <strong
                            style={{
                              color: "#2c3e50",
                              minWidth: "60px",
                              display: "inline-block",
                            }}
                          >
                            Region:
                          </strong>{" "}
                          {props.item.collection &&
                            props.item.collection.reciver_distrcit}
                          {props.item.collection &&
                            props.item.collection.reciver_state &&
                            `, ${props.item.collection.reciver_state}`}
                          {props.item.collection &&
                            props.item.collection.recivercountries &&
                            props.item.collection.recivercountries.name &&
                            `, ${props.item.collection.recivercountries.name}`}
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colSpan={5}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "20px 0",
                        // margin: "15px 0",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "8px",
                        paddingLeft: "15px",
                        paddingRight: "15px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "30px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <span style={{ fontWeight: "500", fontSize: "14px" }}>
                            Booking No :
                          </span>
                          <span style={{ fontSize: "14px", fontWeight: "600" }}>
                            {props.item && props?.item?.collection_id}
                          </span>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <span style={{ fontWeight: "500", fontSize: "14px" }}>
                            Total Pieces:
                          </span>
                          <span style={{ fontSize: "14px", fontWeight: "600" }}>
                            {data && data?.boxes
                              ? data.boxes.length
                              : props.item?.collection?.boxes?.length || 0}
                          </span>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <span style={{ fontWeight: "500", fontSize: "14px" }}>
                            Total Weight :
                          </span>
                          <span style={{ fontSize: "14px", fontWeight: "600" }}>
                            {" "}
                            {data && data?.boxes
                              ? data.boxes
                                  .reduce(
                                    (sum, box) =>
                                      sum +
                                      (parseFloat(box.chargable_weight) || 0),
                                    0
                                  )
                                  .toFixed(2)
                              : "0.00"}{" "}
                            kg
                          </span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <span style={{ fontWeight: "500", fontSize: "14px" }}>
                            Service:
                          </span>
                          <span style={{ fontSize: "14px", fontWeight: "700" }}>
                            {props.item.service &&
                              props.item.service.name &&
                              props.item.service.name}
                          </span>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                <br />
                <tr>
                  <td colSpan={5}>
                    <div className="print-invoice-txt4">BOXES DETAILS</div>
                  </td>
                </tr>
                <br />
                <tr>
                  <td colSpan={5}>
                    <table
                      className="print-invoice-table"
                      style={{ width: "100%" }}
                    >
                      <tr>
                        <th
                          className="print-invoice-table-td"
                          style={{ width: "25%" }}
                        >
                          <div className="print-customsInvoice-txt5">
                            Box Number
                          </div>
                        </th>
                        <th
                          className="print-invoice-table-td"
                          style={{ width: "40%" }}
                        >
                          <div className="print-customsInvoice-txt5">Items</div>
                        </th>
                        <th
                          className="print-invoice-table-td"
                          style={{ width: "15%" }}
                        >
                          <div className="print-customsInvoice-txt5">
                            Weight
                          </div>
                        </th>
                        <th
                          className="print-invoice-table-td"
                          style={{ width: "20%" }}
                        >
                          <div className="print-customsInvoice-txt5">
                            Service
                          </div>
                        </th>
                      </tr>
                      {data &&
                        data.boxes &&
                        data.boxes.map((box, index) => {
                          // Get all items for this box
                          const boxItems = box.boxitems
                            ? box.boxitems.map((item) => item.item).join(", ")
                            : "";

                          return (
                            <tr key={index}>
                              <td className="print-invoice-table-td">
                                <div className="print-customsInvoice-txt6">
                                  {box.box_number}
                                </div>
                              </td>
                              <td className="print-invoice-table-td">
                                <div className="print-customsInvoice-txt6">
                                  {boxItems}
                                </div>
                              </td>
                              <td className="print-invoice-table-td">
                                <div className="print-customsInvoice-txt6">
                                  {box.chargable_weight}
                                </div>
                              </td>
                              <td className="print-invoice-table-td">
                                <div className="print-customsInvoice-txt6">
                                  {box.service && box.service.name}
                                </div>
                              </td>
                            </tr>
                          );
                        })}

                      {/* Total row */}
                      {data && data?.boxes && data?.boxes?.length > 0 && (
                        <tr
                          style={{
                            backgroundColor: "#f2f2f2",
                            fontWeight: "bold",
                          }}
                        >
                          <td className="print-invoice-table-td">
                            <div className="print-customsInvoice-txt6">
                              Total Weight
                            </div>
                          </td>
                          <td className="print-invoice-table-td">
                            <div className="print-customsInvoice-txt6"></div>
                          </td>
                          <td className="print-invoice-table-td">
                            <div className="print-customsInvoice-txt6">
                              {data.boxes
                                .reduce(
                                  (sum, box) =>
                                    sum +
                                    (parseFloat(box.chargable_weight) || 0),
                                  0
                                )
                                .toFixed(2)}
                            </div>
                          </td>
                          <td className="print-invoice-table-td">
                            <div className="print-customsInvoice-txt6"></div>
                          </td>
                        </tr>
                      )}
                    </table>
                  </td>
                </tr>

                <tr>
                  <td colSpan={5}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        marginTop: "30px",
                        padding: "20px 0",
                        borderTop: "1px solid #ddd",
                      }}
                    >
                      {/* Sender Signature Section - Left Side */}
                      <div
                        style={{
                          width: "45%",
                          textAlign: "left",
                        }}
                      >
                        <div
                          style={{
                            fontWeight: "bold",
                            fontSize: "14px",
                            marginBottom: "15px",
                            color: "#2c3e50",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Sender Signature
                        </div>
                        <div
                          style={{
                            minHeight: "80px",
                            marginBottom: "5px",
                          }}
                        >
                          {props.item.signature ? (
                            <img
                              src={props.item.signature}
                              className="print-invoice-signature"
                              style={{
                                maxWidth: "150px",
                                maxHeight: "100px",
                                objectFit: "contain",
                              }}
                            />
                          ) : (
                            <div />
                          )}
                        </div>
                      </div>

                      {/* Company Section - Right Side */}
                      <div
                        style={{
                          width: "45%",
                          textAlign: "right",
                        }}
                      >
                        <div
                          style={{
                            fontWeight: "bold",
                            fontSize: "14px",
                            marginBottom: "15px",
                            color: "#2c3e50",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                          }}
                        >
                          For Sahari International Courier
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "end",
                            alignItems: "center",
                            gap: "20px",
                            minHeight: "80px",
                          }}
                        >
                          <img
                            src={Companyseal}
                            style={{
                              maxWidth: "150px",
                              maxHeight: "100px",
                              objectFit: "contain",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>

          <Row>
            <Col sm="6"></Col>
            <Col sm="3">
              <Button onClick={() => props.onClose()} block size="large">
                Cancel
              </Button>
            </Col>
            <Col sm="3">
              <ReactToPrint
                trigger={() => (
                  <Button
                    type="primary"
                    size="large"
                    block
                    onClickCapture={() => {
                      isPrinted();
                    }}
                  >
                    Print
                  </Button>
                )}
                content={() => componentRef.current}
              />
            </Col>
          </Row>
        </div>
      )}
    </Modal>
  );
}
export default PrintCustomerInvoiceModal2;
